/* DYNAMO · Mengen-Kacheln auf der Produktseite (Agent W, 06.10.2026).
   Die gewählte Kachel setzt die Menge im Horizon-Kaufformular (unsichtbares Mengenfeld, öffentliche API setValue/onQuantityChange).
   Beim Variantenwechsel holt sich der Block seine neuen Preise aus der Antwort, die Horizon ohnehin lädt (ProductSelectEvent). */
import { StandardEvents } from '@shopify/events';

class DYMengeKacheln extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abbruch;

  connectedCallback() {
    this.#abbruch = new AbortController();
    const { signal } = this.#abbruch;
    this.addEventListener('change', this.#beiAuswahl, { signal });
    this.#sektion()?.addEventListener(StandardEvents.productSelect, this.#beiVariante, { signal });
    // Nach dem Laden: Menge im Formular an die gewählte Kachel angleichen (z. B. nach „Zurück“ im Browser)
    requestAnimationFrame(() => this.#anwenden(this.#gewaehlt(), false));
  }

  disconnectedCallback() {
    this.#abbruch?.abort();
  }

  #sektion() {
    return this.closest('.shopify-section, dialog');
  }

  #gewaehlt() {
    const r = /** @type {HTMLInputElement | null} */ (this.querySelector('input[type="radio"]:checked'));
    return r ? Number(r.value) || 1 : 1;
  }

  /** @param {Event} e */
  #beiAuswahl = (e) => {
    const ziel = e.target;
    if (!(ziel instanceof HTMLInputElement) || ziel.type !== 'radio') return;
    this.#anwenden(Number(ziel.value) || 1, true);
  };

  /**
   * @param {number} menge
   * @param {boolean} melden - Horizon-Ereignis auslösen (Kauf-Leiste unten zeigt die Menge)
   */
  async #anwenden(menge, melden) {
    if (this.dataset.faehig !== 'true') return;
    const wert = this.querySelector('[data-dy-menge-wert]');
    const r = /** @type {HTMLInputElement | null} */ (this.querySelector(`input[type="radio"][value="${menge}"]`));
    if (wert && r?.dataset.text) wert.textContent = r.dataset.text;

    const sektion = this.#sektion();
    const formular = sektion?.querySelector('product-form-component');
    if (!formular) return;
    await customElements.whenDefined('quantity-selector-component').catch(() => {});
    /** @type {any} */
    const waehler = formular.querySelector('quantity-selector-component');
    if (waehler && typeof waehler.setValue === 'function') {
      if (String(waehler.getValue?.()) === String(menge) && !melden) return;
      waehler.setValue(String(menge));
      if (melden) waehler.onQuantityChange?.();
      waehler.updateButtonStates?.();
      return;
    }
    // Rückfall: Mengenfeld fehlt im Formular → verstecktes Feld anlegen
    const form = formular.querySelector('form');
    if (!form) return;
    let feld = /** @type {HTMLInputElement | null} */ (form.querySelector('input[name="quantity"]'));
    if (!feld) {
      feld = document.createElement('input');
      feld.type = 'hidden';
      feld.name = 'quantity';
      form.appendChild(feld);
    }
    feld.value = String(menge);
  }

  /** @param {any} event - ProductSelectEvent */
  #beiVariante = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then((/** @type {any} */ { detail }) => {
        const html = detail?.html;
        if (!html) return;
        const neu = html.querySelector(`dy-menge-kacheln[data-block-id="${this.dataset.blockId}"]`);
        if (!neu) return;
        const menge = this.#gewaehlt();
        this.dataset.faehig = neu.dataset.faehig || 'false';
        this.className = neu.className;
        this.innerHTML = neu.innerHTML;
        const r = /** @type {HTMLInputElement | null} */ (this.querySelector(`input[type="radio"][value="${menge}"]`));
        if (r) r.checked = true;
        this.#anwenden(r ? menge : 1, false);
      })
      .catch((/** @type {any} */ fehler) => {
        if (fehler?.name !== 'AbortError') console.warn('[dy-menge] Variantenwechsel:', fehler);
      });
  };
}

if (!customElements.get('dy-menge-kacheln')) {
  customElements.define('dy-menge-kacheln', DYMengeKacheln);
}
